import { NumberFormat } from "components/Common/NumberFormat/NumberFormat";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { couponCodeAtom } from "src/atoms";
import { VAT } from "src/config/priceTypeList";
import { useProductFlags } from "src/hooks/recoil/useProductFlags";
import { getProductFromSessionStorage } from "src/utils/storage/auth";

interface IServicePaymentInfoProps {
  userPerPrice: number;
  userPerPriceYear: number;
  payCompany: string;
  currency: string;
}

// 서비스 구독 & 결제 정보
const ServicePaymentInfoRow = ({
  userPerPrice,
  userPerPriceYear,
  payCompany,
  currency,
}: IServicePaymentInfoProps) => {
  const { isOciProduct } = useProductFlags();
  const { t } = useTranslation();
  const [couponCodeInfo] = useRecoilState(couponCodeAtom);
  const { watch } = useFormContext();
  const priceType = watch("priceType");
  const licenseCount = watch("licenseCount");
  const payTerm = watch("payTerm");
  const totalPrice = watch("totalPrice");

  const isEcoProduct =
    isOciProduct && getProductFromSessionStorage() === "WRAPSODY_ECO";
  const displayLicenseCount =
    licenseCount < 10 ? (isEcoProduct ? licenseCount : 10) : licenseCount;
  const isYearly = payTerm === "year";
  const isCouponPercent = couponCodeInfo?.discountType === "PERCENT";
  // (isCash 판정은 현재 미사용 주석 블록에서만 참조되어 제거)

  const getText = (keySuffix: string) =>
    priceType ? t(`siteType.${priceType}.orderSpecification.${keySuffix}`) : "";

  const calcDiscount = () => {
    const discount =
      (userPerPrice - userPerPriceYear) * licenseCount * 12 * VAT;
    // const count = licenseCount < 10 || licenseCount > 9999 ? licenseCount : 10;
    // return Math.floor(isEcoProduct ? discount * licenseCount : discount * 10);
    return Math.floor(discount);
  };

  return (
    <div className="form-item" style={{ marginBottom: 0 }}>
      <div className="flex align-center">
        <div className="width w-30p">
          <span className="form-item-title">{getText("subscription")}</span>
        </div>
        <div className="width w-70p text right">
          <span className="form-item-title">{getText("price")}</span>
        </div>
      </div>

      <div className="flex align-center">
        <div className="width w-30p">
          <span>
            {t(`siteType.${priceType}.orderSpecification.subscribedUsers`, {
              0: displayLicenseCount,
            })}
          </span>
        </div>
        <div className="width w-70p text right">
          <span>
            <NumberFormat
              num={
                isYearly
                  ? Math.floor(userPerPriceYear * licenseCount * 12 * VAT)
                  : Math.floor(userPerPrice * displayLicenseCount * VAT)
              }
              currency={currency}
            />
            {getText(isYearly ? "year" : "month")}
          </span>
        </div>
      </div>

      <div className="flex align-center">
        <div className="width w-30p"></div>
        <div className="width w-70p text right">
          {isYearly && (
            <span className="inline-block vertical-middle mg ml-10 text text--green">
              {getText("annulDiscount")}
              <NumberFormat num={calcDiscount()} currency={currency} />
            </span>
          )}
          {couponCodeInfo && (
            <span className="inline-block vertical-middle mg ml-10 text text--green">
              {"할인쿠폰 적용 "}
              {isCouponPercent ? (
                `${couponCodeInfo.discountPrice}%`
              ) : (
                <NumberFormat
                  num={couponCodeInfo.discountPrice}
                  currency={currency}
                />
              )}
            </span>
          )}
        </div>
      </div>

      <hr style={{ margin: "5px 0px 0px 0px", borderStyle: "dashed" }} />

      <div className="flex align-center mg mt-20">
        <div className="width w-30p">
          <span className="form-item-total">{getText("total")}</span>
        </div>
        <div className="width w-70p text right">
          <span className="form-item-total">
            {/* totalPrice - PriceChecker에서 세팅 */}
            <NumberFormat
              num={totalPrice}
              currency={currency}
            />
            {getText(isYearly ? "year" : "month")}
          </span>
        </div>
      </div>

      {/* {(isCash || payCompany === "PAYPAL") && ( */}
      {/* )} */}

      <hr style={{ marginBottom: 4 }} />
      <div className="flex align-center">
        <div className="width w-30p"></div>
        <div className="width w-70p text right">
          <p className="text text--gray">
            {t(
              "siteManagement.paymentHistory.popUp.changePaymentCycle.info.Msg4"
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServicePaymentInfoRow;
